import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'mm-sider-header',
  templateUrl: './sider-header.component.html',
  styleUrls: ['./sider-header.component.scss']
})
export class AppSiderHeaderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
